import * as React from 'react'
import { backTen, forwardTen } from '../../helpers/historyHelper.ts'
import historyStore from '../../store/historyStore.ts'
import { DateButton } from './components/DateButton.tsx'
import { IPet } from '../../interfaces/types.ts'
import { PetPickerModal } from '../../forms/v2/components/PetPickerModal.tsx'
import dataStore from '../../store/dataStore.ts'
import controlStore from '../../store/controlStore.ts'
import { centerMap } from '../map/mapHelpers.tsx'

interface Props {
}
const MAX_LOCATIONS = 10

export const HistoryButtons: React.FC<Props> = () => {
    const startDate = historyStore(s => s.startDate)
    const endDate = historyStore(s => s.endDate)
    const reachedStart = historyStore(s => s.reachedStart)
    const locations = historyStore(s => s.locations)
    const isMovieMode = historyStore(s => s.isMovieMode)
    const pets = dataStore(s => s.pets)
    const selectedPetId = historyStore(s => s.selectedPetId)
    const isMobile = controlStore(s => s.isOnMobileDevice)
    const [curJump, setCurJump] = React.useState<number>(0)
    const map = historyStore(s => s.map)

    const noHistory = selectedPetId && isMobile && !locations?.length

    const empty = (<div className={'text-primary bg-primary-content text-xl mt-4'}>No history available</div> )

    const getNextJump = (cur: number, direction: 'up' | 'down') => {
        let index =  cur - 1
        if (direction === 'up') {
            index = (index + 1) % MAX_LOCATIONS
        } else if (direction === 'down') {
            index = (index - 1 + MAX_LOCATIONS) % MAX_LOCATIONS
        }
        centerMap(locations[index], map!)
        return index + 1
    }

    React.useEffect(() => {
        setCurJump(0)
    }, [locations])

    const jumpControl = (
        <div className={'rounded-l-full rounded-r-full p-2 w-[50%] bg-white text-secondary mt-6 ml-auto mr-auto h-fit text-xl border-2 border-secondary'}>
            <div className={'flex items-center justify-between'}>
                <div className={'text-secondary text-3xl font-semibold'}
                     onClick={() => setCurJump(getNextJump(curJump, 'down'))}
                >-</div>
                {curJump !== 0 ? curJump : 'pan to location'}
                <div className={'text-secondary text-3xl font-semibold'}
                     onClick={() => setCurJump(getNextJump(curJump, 'up'))}
                >+</div>
            </div>
        </div>
    )

    const controls = (
        <div id={'history-buttons'} className={'flex flex-row w-[100vw] justify-between px-4'}>
            <DateButton direction={'newer'}
                        reachedStart={reachedStart}
                        historyAvailable={locations.length}
                        backwardTen={async (e) => {
                            const stateUpdate = await backTen(e)
                            historyStore.getState().setStateUpdate(stateUpdate)
                        }}
                        forwardTen={async (e) => {
                            const stateUpdate = await forwardTen(e)
                            historyStore.getState().setStateUpdate(stateUpdate)
                        }}
                        selectingDate={false}
                        date={startDate}
            />
            {isMobile ? <PetPickerModal
                onChange={(p: IPet | null) => {
                    historyStore.getState().setSelectedPetId(p?._id || '')
                }}
                pet={pets.find(p => p._id === selectedPetId) || null}
            /> : null}
            <DateButton direction={'older'}
                        reachedStart={reachedStart}
                        historyAvailable={locations.length}
                        backwardTen={async (e) => {
                            const stateUpdate = await backTen(e)
                            historyStore.getState().setStateUpdate(stateUpdate)
                        }}
                        forwardTen={async (e) => {
                            const stateUpdate = await forwardTen(e)
                            historyStore.getState().setStateUpdate(stateUpdate)
                        }}
                        selectingDate={false}
                        date={endDate}
            />
        </div>
    )

    const container = (
        <div className={''}>
            {controls}
            {noHistory ? empty : null}
            {isMobile && selectedPetId && !noHistory ? jumpControl : null}
        </div>
    )

    return !isMovieMode ? container : null
}
